import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { ClaimDashboardAction, ClaimDashboardActionTypes } from './claim-v2-dashboard.actions';
import { DashboardClaimV2 } from './claim-v2-dashboard.models';

export const CLAIM_V2_DASHBOARD_FEATURE_KEY = 'claimV2Dashboard';

export interface ClaimDashboardState extends EntityState<DashboardClaimV2> {
  loading: boolean;
  loaded: boolean;
  hasError: boolean;
  error: unknown;
}

export const adapter: EntityAdapter<DashboardClaimV2> = createEntityAdapter<DashboardClaimV2>({
  selectId: (claim: DashboardClaimV2) => claim.claimNumber,
  sortComparer: sortByClaimNumber
});

export function sortByClaimNumber(a: DashboardClaimV2, b: DashboardClaimV2): number {
  return parseInt(b.claimNumber, 10) - parseInt(a.claimNumber, 10);
}

export const initialState: ClaimDashboardState = adapter.getInitialState({
  loading: false,
  loaded: false,
  hasError: false,
  error: null
});

export function claimV2DashboardReducer(
  state = initialState,
  action: ClaimDashboardAction
): ClaimDashboardState {
  switch (action.type) {
    case ClaimDashboardActionTypes.LOAD_CLAIM_V2_DASHBOARD: {
      return { ...state, loading: true, loaded: false, hasError: false };
    }

    case ClaimDashboardActionTypes.LOAD_CLAIM_V2_DASHBOARD_SUCCESS: {
      const newState = { ...state, loading: false, loaded: true };
      return adapter.setAll(action.payload, newState);
    }

    case ClaimDashboardActionTypes.LOAD_CLAIM_V2_DASHBOARD_FAIL: {
      return {
        ...state,
        error: action.payload,
        loading: false,
        loaded: true,
        hasError: true
      };
    }

    default:
      return state;
  }
}

const { selectAll } = adapter.getSelectors();
export const selectAllDashboardClaims = selectAll;
